export function canPrintGRN(status) {
  return ['approved', 'returned'].includes(status);
}

export function canPrintSupplierReturnNote(status) {
  return ['approved', 'processed', 'completed'].includes(status);
}

export function canPrintDebitNote(status) {
  return ['approved', 'completed'].includes(status);
}

export function canPrintPurchaseOrder(status) {
  return [
    'approved', 'sent_to_supplier', 'acknowledged',
    'partially_received', 'received', 'invoiced', 'paid', 'closed',
  ].includes(status);
}

export function canPrintPurchaseRequest(status) {
  return ['approved', 'converted_to_po'].includes(status);
}

export function canPrintSupplierPayment(status) {
  return ['approved', 'paid'].includes(status);
}
